import { render, staticRenderFns } from "./MailingList.vue?vue&type=template&id=41211e6a&"
import script from "./MailingList.vue?vue&type=script&lang=js&"
export * from "./MailingList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports